<template>
  <div class="book" :class="{guide: book.guide, finalized: !book.editable}">
    <div class="book-menu" @click.stop>
      <div class="book-menu__trigger" @click="showMenu = !showMenu">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>
      </div>
      <div class="book-menu__dropdown" v-show="showMenu">
        <div class="book-menu__item" @click="onMenuPreview">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>
          {{$t('book.buttonPreview')}}
        </div>
        <div class="book-menu__item book-menu__item--danger" @click="onMenuDelete">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
          {{$t('button.delete')}}
        </div>
      </div>
    </div>
    <!--封面-->
    <div :class="['book-cover', { 'book-cover--a5': isA5 }]" @click="previewLink">
      <img v-if="book.coverUrl" :src="book.coverUrl" alt="" class="cover-img">
      <cover v-else :book="book"></cover>
      <span class="book-new-ribbon" v-if="isNewBook && !dismissed">New</span>
    </div>
    <!--信息-->
    <div class="book-info">
      <h4 class="book-title text-ellipsis">
        <a @click="previewLink">
          <i :class="['fa', iconClass]" aria-hidden="true"></i>
          {{book.title}}
        </a>
      </h4>
      <div class="info-detail">
        <p>{{book.author}}</p>
        <p v-if="book.totalPage" class="book-spec">
          <span class="spec-tag">{{innerStyle}}</span>
          <span class="spec-sep">-</span>
          <span class="spec-tag">{{$t('book.page', { page: book.totalPage })}}</span>
        </p>
        <p class="text-mini" v-if="book.updatedAt || book.createdAt">
          <i class="icon ion-ios-information text-done"></i>
          {{$t('book.labelUpdatedAt')}} {{formatDate(book.updatedAt || book.createdAt)}}
        </p>
      </div>
      <div class="book-btns">
        <button class="btn default edit" @click="handleEdit" v-if="book.editable">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          {{$t('book.buttonEdit')}}
        </button>
        <router-link :to="handleLink('review', book.bid, book.totalPage, book.source)" v-else>
          <button class="btn default">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>
            {{$t('book.buttonPreview')}}
          </button>
        </router-link>
        <button class="btn primary purchase" :class="{disabled: isChecking}" @click.prevent="checkBookStatus"
                v-if="book.totalPage">
          <i class="fa fa-spinner fa-spin" v-if="isChecking"></i>
          <svg v-else viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
          {{$t('book.buttonPurchase')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import config from 'src/app.config'
import FBShare from '../../../mixins/FBShare'
import { mapGetters } from 'vuex'
import Cover from '../../../components/Cover'
import api from 'src/api'

export default {
  name: 'book',
  components: { Cover },
  mixins: [FBShare],
  props: {
    book: {
      type: Object,
      default: function () {
        return {
          bid: '',
          title: '',
          author: '',
          cover: '',
          createdAt: new Date(),
          updatedAt: new Date(),
          endAt: '',
          status: '0',
          template: 'common.text.a5Waterfall',
          totalPage: 0,
          editable: true,
          public: false,
          guide: false
        }
      }
    }
  },
  data () {
    return {
      template: config.templates,
      finalizedConfig: [
        {
          langRef: 'jp',
          className: 'jp'
        },
        {
          langRef: 'en',
          className: 'en'
        },
        {
          langRef: 'zh',
          className: 'zh'
        },
        {
          langRef: 'ko',
          className: 'en'
        }
      ],
      langRef: 'en',
      showAction: false,
      showMenu: false,
      dismissed: false,
      isChecking: false
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    iconClass () {
      if (this.book.type === 'photobook') {
        return 'fa-photo text-primary'
      }
      if (this.book.type === 'calendar') {
        return 'fa-calendar text-primary '
      }
      return 'fa-book text-fb'
    },
    isA5 () {
      return /^a5/i.test(this.book.typeset)
    },
    isNewBook () {
      // Check if dismissed in localStorage
      const dismissedBooks = JSON.parse(localStorage.getItem('ipb_dismissed_new') || '[]')
      if (dismissedBooks.includes(this.book.bid)) return false
      if (this.book.isNew) return true
      if (!this.book.createdAt) return false
      const created = new Date(this.book.createdAt).getTime()
      const now = Date.now()
      return (now - created) < 24 * 60 * 60 * 1000
    },
    innerStyle () {
      const {
        template,
        templateStyle,
        design
      } = this.book
      let title
      let material
      let style
      switch (this.book.type) {
        case 'diarybook':
          return this.$t(template)
        case 'photobook':
          if (template === 'album') {
            return 'A4雜誌冊'
          }
          title = t => `${t}相片書`
          material = design.template.includes('leather') ? '皮面' : '布藝'
          style = '簡約版'
          if (templateStyle === 'magazine-1' && templateStyle.includes('travel')) {
            style = '旅行風'
          }
          if (templateStyle.includes('love')) {
            style = '爱情風'
          }
          if (templateStyle.includes('japan')) {
            style = '日系風'
          }
          if (templateStyle.includes('baby')) {
            style = '幼兒版'
          }
          if (templateStyle.includes('child')) {
            style = '童趣版'
          }
          return title(material) + ' ' + style
        case 'calendar':
          return '月曆'
        default:
          return ''
      }
    }
  },
  methods: {
    handleEdit () {
      if (this.book.type === 'photobook' || this.book.type === 'calendar') {
        window.location.href = `https://ipastbook.com/app/design/album/?aid=${this.book.bid}&type=${this.book.type}&from=${encodeURIComponent(
          window.location.href)}`
        return
      }
      const {
        bid,
        totalPage,
        source,
        isGettingPages,
        isGettingPosts,
        pagesInitialized,
        postsInitialized,
        patched,
        insInitialized,
        isGettingIns
      } = this.book
      const hasData = isGettingPages || isGettingPosts || pagesInitialized || postsInitialized || patched || insInitialized || isGettingIns
      if (!hasData && !totalPage) {
        // Completely empty book — go to Manage Content
        this.$router.push({
          name: 'selection',
          query: { bid, sid: source }
        })
        return
      }
      // Navigate to preview with auto-open editor
      this.$router.push({
        name: 'preview',
        query: {
          bid,
          sid: source,
          edit: '1'
        }
      })
    },
    previewLink () {
      if (this.isNewBook) {
        this.dismissed = true
        this.book.isNew = false
        const dismissedBooks = JSON.parse(localStorage.getItem('ipb_dismissed_new') || '[]')
        if (!dismissedBooks.includes(this.book.bid)) {
          dismissedBooks.push(this.book.bid)
          localStorage.setItem('ipb_dismissed_new', JSON.stringify(dismissedBooks))
        }
      }
      if (this.book.type === 'photobook' || this.book.type === 'calendar') {
        window.location.href = `https://ipastbook.com/app/design/album/?aid=${this.book.bid}&type=${this.book.type}&from=${encodeURIComponent(
          window.location.href)}`
        return
      }
      if (!this.book.totalPage) {
        this.handleEdit()
      }
      if (this.book.totalPage) {
        if (!this.book.editable) {
          this.$router.push({
            name: 'review',
            query: {
              bid: this.book.bid,
              sid: this.book.source
            }
          })
          return
        }
        this.$router.push({
          name: 'preview',
          query: {
            bid: this.book.bid,
            sid: this.book.source
          }
        })
      }
    },
    formatDate (date) {
      return this.$moment(date).format('YYYY/MM/DD')
    },
    shareBook () {
      this.showAction = false
      this.FBShareBook(this.book.bid)
    },
    checkBookStatus () {
      if (this.book.type !== 'diarybook') {
        if (this.isChecking) return
        this.isChecking = true
        const checkHandler = {
          photobook: api.checkPhotoBook,
          calendar: api.checkCalendar
        }
        const request = checkHandler[this.book.type]
        request(this.book.bid).then(data => {
          this.isChecking = false
          const {
            pageIndex,
            pagesValid
          } = data
          if (pageIndex + 1) {
            this.$confirm({
              title: `书籍第${pageIndex + 1}頁圖片缺失`,
              okText: '查看',
              cancelText: '知道了',
              onOk: (modal) => {
                modal.close()
                const origin = /test|localhost/.test(window.location.origin) ? window.location.origin : 'https://ipastbook.com'
                window.location.href = `${origin}/app/design/album/?aid=${this.book.bid}&type=${this.book.type}`
              }
            })
          } else if (pagesValid) {
            const tip = pagesValid < 0 ? '書籍頁數太少，再去寫寫吧' : '書籍頁數太多了，去刪點頁數吧'
            this.$confirm({
              title: tip,
              okText: '查看',
              cancelText: '知道了',
              onOk: (modal) => {
                modal.close()
                const origin = /test|localhost/.test(window.location.origin) ? window.location.origin : 'https://ipastbook.com'
                window.location.href = `${origin}/app/design/album/?aid=${this.book.bid}&type=${this.book.type}`
              }
            })
          } else {
            this.$router.push({
              name: 'order-check',
              query: {
                bid: this.book.bid,
                sid: this.book.source,
                bookType: this.book.type
              }
            })
          }
        }).catch(e => {
          this.isChecking = false
        })
      } else {
        this.$router.push({
          name: 'order-check',
          query: {
            bid: this.book.bid,
            sid: this.book.source,
            bookType: this.book.type
          }
        })
      }
    },
    toggleMenu () {
      this.showMenu = !this.showMenu
    },
    onMenuPreview () {
      this.showMenu = false
      this.goPreview()
    },
    onMenuDelete () {
      this.showMenu = false
      this.$emit('delete', this.book)
    },
    goPreview () {
      const { bid, source } = this.book
      if (!bid) {
        this.$toast({ message: '書籍無顯示內容' })
        return
      }
      this.$router.push({
        name: 'preview',
        query: { bid, sid: source }
      })
    },
    handleLink (name, bid, page, source) {
      if (!bid) {
        this.$toast({
          message: '書籍無顯示內容'
        })
        return
      }
      return {
        name,
        query: {
          bid,
          sid: source
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/variables';
.book {
  width: 100%;
  position: relative;
  overflow: visible;
  border-radius: 12px;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  font-size: 16px;
  border: 1px solid transparent;
  transition: all 0.25s;

  &:hover {
    background-color: white;
    border-color: #e5e7eb;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

    .book-menu {
      opacity: 1;
    }
  }

  &.finalized {
    .edit {
      display: none;
    }
  }

  .book-menu {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
    opacity: 0;
    transition: opacity 0.2s;

    &__trigger {
      cursor: pointer;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      color: #6b7280;
      font-size: 14px;

      &:hover {
        background: #fff;
        color: $el-color-primary;
      }
    }

    &__dropdown {
      position: absolute;
      top: 100%;
      right: 0;
      margin-top: 4px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      min-width: 140px;
      overflow: hidden;
      z-index: 10;
    }

    &__item {
      padding: 10px 16px;
      font-size: 13px;
      color: #374151;
      display: flex;
      align-items: center;
      gap: 8px;
      white-space: nowrap;
      cursor: pointer;
      transition: background 0.15s;

      &:hover {
        background: #f3f4f6;
      }

      &--danger {
        color: #ef4444;
        &:hover {
          background: #fef2f2;
        }
      }
    }
  }

  .book-cover {
    flex: 0 0 auto;
    width: 230px;
    cursor: pointer;
    padding: 1.25rem;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;

    &--a5 {
      width: 190px;
    }

    .book-new-ribbon {
      position: absolute;
      top: 1.25rem;
      right: calc(16px + 1.25rem);
      min-width: 40px;
      background: #e53935;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 8px 10px;
      z-index: 3;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.5px;
      line-height: 1;
      filter: drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.25));
      clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 6px), 0 100%);
    }

    .cover-img {
      width: 100%;
      height: auto;
      object-fit: contain;
      border-radius: 1px 3px 3px 1px;
      border-left: 4px solid #ddd9d4;
      box-shadow:
        3px 3px 6px rgba(0, 0, 0, 0.15),
        6px 6px 12px rgba(0, 0, 0, 0.08);
    }

    ::v-deep .cover {
      width: 100%;
    }

    ::v-deep .cover-holder {
      width: 100%;
      box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.15);
      border-radius: 2px;
    }

    @media (max-width: 767px) {
      width: 160px;
      padding: 0.75rem;
    }
  }

  .book-info {
    flex: 1;
    min-width: 0;
    padding: 1.5rem 1.5rem 1.5rem 0.75rem;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .book-title {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 4px;
    cursor: pointer;

    a:hover {
      color: $el-color-primary;
    }

    i {
      margin-right: 4px;
      font-size: 14px;
    }
  }

  .info-detail {
    font-size: 13px;
    color: #9ca3af;

    p {
      margin: 0;
      line-height: 1.5;
    }
  }

  .book-spec {
    display: inline-flex;
    align-items: center;
    background: #f3f4f6;
    border-radius: 100px;
    padding: 4px 14px;
    margin: 6px 0 !important;
    font-size: 12px;
    color: #374151;
    font-weight: 500;

    .spec-sep {
      margin: 0 6px;
      color: #d1d5db;
    }

    .spec-tag {
      white-space: nowrap;
    }
  }

  .book-btns {
    margin-top: 50px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    button {
      min-width: 100px;
      font-weight: 500;
      font-size: 13px;
      padding: 6px 22px;
    }

    @media (max-width: 767px) {
      margin-top: 20px;

      button {
        min-width: 70px;
        padding: 6px 14px;
        font-size: 12px;
      }
    }
  }

  // 删除按钮
  .book-item__action {
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    height: 24px;
    line-height: 24px;
    width: 24px;
    color: white;
    cursor: pointer;

    i {
      position: relative;
      z-index: 2;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      border: {
        top: 20px solid #F56368;
        right: 20px solid #F56368;
        left: 20px solid transparent;
        bottom: 20px solid transparent;
      }
    }

    &.bin {
      &:before {
        border-top-color: #999 !important;
        border-right-color: #999 !important;
      }
    }

    span {
      color: #333;
      font-size: 12px;
    }

    .pointer {
      max-width: 3em;
      position: absolute;
      left: -3em;
      bottom: -1.75em;
      @media (max-width: 767px) {
        max-width: 2.8em;
        left: -3.4em;
        bottom: -1.05em;
      }
    }
  }

  .action-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .35);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;

    .sub-action {
      color: white;
      cursor: pointer;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 40px;
        background-color: rgba(255, 255, 255, .35);
        border: 2px solid white;
        border-radius: 50%;
      }

      p {
        font-size: 14px;
        font-weight: 600;
      }
    }

    .sub-action + .sub-action {
      margin-left: 30px;
    }
  }

  .slide-down-enter-active, .slide-down-leave-active {
    transition: all .35s
  }

  .slide-down-enter, .slide-down-leave-to /* .fade-leave-active in below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(-50px);
  }
}
</style>
